import {Component, computed, inject} from '@angular/core';
import {TranslocoDirective, TranslocoPipe} from '@jsverse/transloco';
import {ProjectBaseStepComponent} from '../../../../project-base-step/project-base-step.component';
import {SystemRecordingStateService} from '../system-recording-state.service';
import {SystemRecordingModuleHrComponent} from './system-recording-module-hr/system-recording-module-hr.component';
import {SystemRecordingModuleNonHrComponent} from './system-recording-module-non-hr/system-recording-module-non-hr.component';
import {CardTitleComponent} from '../../../../../../../shared/components/header/card-title/card-title.component';
import {LoadingComponent} from '../../../../../../../shared/components/loading/loading.component';
import {AuditInfoComponent} from '../../../../../../../shared/components/audit-info/audit-info.component';

@Component({
  selector: 'app-step-3-1-system-recording-editor',
  imports: [
    TranslocoDirective,
    TranslocoPipe,
    SystemRecordingModuleHrComponent,
    SystemRecordingModuleNonHrComponent,
    CardTitleComponent,
    LoadingComponent,
    AuditInfoComponent,
  ],
  templateUrl: './step-3-1-system-recording-editor.component.html',
})
export class Step31SystemRecordingEditorComponent extends ProjectBaseStepComponent {
  private readonly systemRecordingStateService = inject(SystemRecordingStateService);

  protected moduleData = computed(() => this.systemRecordingStateService.moduleData());
  protected isLoading = computed(() => this.systemRecordingStateService.loading());
  protected auditInfo = computed(() => this.systemRecordingStateService.auditInfo());

  override ngOnInit(): void {
    super.ngOnInit();
    this.loadData();
  }

  private async loadData(): Promise<void> {
    this.systemRecordingStateService.loading.set(true);
    try {
      await this.systemRecordingStateService.initialize(this.projectId);
    } finally {
      this.systemRecordingStateService.loading.set(false);
    }
  }
}
